export const CLASSMED_NINETY_DAY_DISCOUNT_PERCENT = 20;
export const CLASSMED_NINETY_DAY_DISCOUNT_FACTOR = 0.8;

export const calculateClassmedNinetyDayPrice = (monthlySubtotal) =>
  Math.round(Number(monthlySubtotal || 0) * 3 * CLASSMED_NINETY_DAY_DISCOUNT_FACTOR);
